var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 66,
    viewBox: "0 0 69 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.711578 20.4286C0.711578 11 0.711578 9.03572 0.711578 5.5C0.711578 0.392852 5.50375 0 7.89984 0C10.2959 0 16.6855 0 23.075 0C27.8672 0 30.6626 2.35714 30.6626 6.2857C30.6626 9.42857 30.6626 30.25 30.6626 30.25H29.0653C15.4874 30.25 30.6626 56.9643 30.6626 56.9643V66C19.4809 66 0.711578 53.0357 0.711578 20.4286ZM39.0489 20.4286C39.0489 11 39.0489 9.03572 39.0489 5.5C39.0489 0.392852 43.8411 0 46.2372 0C48.6333 0 55.0228 0 61.4124 0C66.2046 0 69 2.35714 69 6.2857C69 9.42857 69 30.25 69 30.25H67.4026C53.8248 30.25 69 56.9643 69 56.9643V66C57.8183 66 39.0489 53.0357 39.0489 20.4286Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/Quote.d32f82d0.svg";
export { ForwardRef as ReactComponent };